module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iqizj"))).then(() => parcelRequire('hEqeo'));